var React = require('react');

function LightModeIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 16.0909C12.9162 16.0909 16.0909 12.9162 16.0909 9C16.0909 5.0838 12.9162 1.90909 9 1.90909C5.0838 1.90909 1.90909 5.0838 1.90909 9C1.90909 12.9162 5.0838 16.0909 9 16.0909ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z","fill":"#A5A9AF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 18V0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z","fill":"#A5A9AF","key":1})]);
}

LightModeIconInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = LightModeIconInline;

LightModeIconInline.default = LightModeIconInline;
